export default function user({ next, store }) {
  if (store.getters["auth/isAuthenticated"]) {
    return next({
      name: "HomePage",
    });
  }
  return next();
}
